import React from "react";
import { separate } from "../../Seprate/Seprate";
import "./FoodDiscountSliderHome.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore } from '@fortawesome/fontawesome-free-solid'
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import 'swiper/swiper-bundle.css';
import { Link } from "react-router-dom"

const points={
    350: {
        slidesPerView: 3,
    },
    450: {
        slidesPerView: 4,
    },
    550: {
        slidesPerView: 4.5,
    },
    670: {
        slidesPerView: 5,
    },
    775: {
        slidesPerView: 5.5,
    },
    906: {
        slidesPerView: 6,
    }, 
    1150: {
        slidesPerView: 6.5,
    },
    1400: {
        slidesPerView: 7,
    }, 
}
export default function FoodDiscountSliderHome({data}) {
  return (
    <>
      <Swiper spaceBetween={20} breakpoints={points} dir="rtl">
        {data.map((item,index)=>{
            return(
                <SwiperSlide key={index}>
                    <div  className={"eachSlide"}>
                        <Link to={item.working_hours.open==="1"?{pathname:`/product/${item.id}/${item.supplier_id}/`,state:item.id}:`/storeClosed/${item.supplier_id}`} state={item}>
                            <div className={"picHolder"}>
                                <img src={`https://cdn.barest.ir/product/m/${item.id}.jpg`} alt={item.name} />
                            </div>
                        </Link>
                        <div className={"information"}>
                            <h4 className={"name"}>{item.name}</h4>
                            <h3 className={"resturantName"}><FontAwesomeIcon icon={faStore} className={"storeIcon"}/>{item.supplier}</h3>
                            <div className={"priceHolder"}>
                                <span className={"offprice"}>{separate(item.off_price)} </span>
                                <span className={"price"}>{ separate(item.price)} </span>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            )
        })}
      </Swiper>
    </>
  );
}
